var map = {
	"./airport-bingbong.wav": 82392,
	"./ding-dong.wav": 66303,
	"./doorbell-bingbong.wav": 74906,
	"./ekiga-vm.wav": 14357,
	"./infobleep.wav": 21100,
	"./quito-mariscal-sucre.wav": 27866,
	"./toydoorbell.wav": 14179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60071;